import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel,  Select as MaterialSelect  ,Box ,TextField,
  LinearProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
Tooltip,
Typography} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
 
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../funciones/ClienteAxios";
import Modal from '../Generales/ModalInformativo';
 
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
     tablaContainer: {
      width: '30.5rem',
      maxHeight: '24rem',
      minHeight: 280,
      //minWidth:'100%',
    },
       tituloEstilo:{
      paddingBottom:'.25rem',
      fontWeight:'bold'
    },
       tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      } 
    },
    hover: {},
    selected: {},
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const ModalDetalle = ({modalAbierto, setModalAbierto, titulo,  registro }) => {
  let history = useHistory();
  const classes = useStyles();
  const auxCol=process.env.REACT_APP_Fondo_Color  
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [listAllMaquinas, setListAllMaquinas] = useState([]); 
  const [listOriginal, setListOriginal] = useState([]); 
 
  React.useEffect(()=>{     
 
    getListAllMaquinaria()
  
    return ()=> {
      source.cancel();
    }     
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

  const getListAllMaquinaria = () => {    
    const data = qs.stringify({
        Usuario:idusu,        
        ip: "127.0.0.0",     
        Categoria:registro.Categoria,
        Obra:registro.Obra,
        Tipo:registro.Tipo ,       
        idDispositivo: "8978yuhjnfrsdsd"
    });
    const url = "/maquinaria/dashboard/detalle";

    function respuesta(auxiliar) 
    { 
        if (auxiliar[0].Id !== -1 && auxiliar[0].Id !== "-1") 
        {  
          setListOriginal(auxiliar)
          
        }
    }
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
  };
 
  const celda = (alinear, estilo, contenido,index) => {
    return (
    <TableCell align={alinear} key={index} className={classes.tableCell} 
      padding={'none'} style={estilo} >
      {contenido}
    </TableCell>)
  }

  const CelTitl=({index,titulo,aline,estilo})=> celda(aline?aline:"center", {...estilo,backgroundColor:auxCol,color:'white',}, titulo?titulo:"",index) 
      
  function TablaEstr(auxDatos) {        
 
    return(        
    <TableContainer className={classes.tablaContainer} id="tamTablaReg"  >
    <Table stickyHeader aria-label="sticky table">
      <TableHead >            
        <TableRow>    
        <CelTitl index={2} titulo={<> {auxDatos.length} Alias </>} aline={"center"} />   
          <CelTitl index={3} titulo={  "Descripción"} aline={"center"} estilo={{fontSize:"13px"}}  />   
          
          <CelTitl index={1} titulo={ "Horometro" } aline={"left"} estilo={{fontSize:"13px"}} />                         
          <CelTitl index={1} titulo={ "NoEco" } aline={"left"} estilo={{fontSize:"13px"}} />
          <CelTitl index={1} titulo={ "Serie" } aline={"left"} estilo={{fontSize:"13px"}} />
          <CelTitl index={1} titulo={ "Notas" } aline={"left"} estilo={{fontSize:"13px"}} />
        </TableRow>                    
      </TableHead>  
      <TableBody>         
      {auxDatos.map((elemnto,index) => {  
            const auxVal=registro?.id === elemnto.id ?false:false                                              
            return (                  
            <TableRow className={classes.tableRow} selected={ auxVal} 
            classes={{ hover: classes.hover, selected: classes.selected }} 
            key={index+1} //onClick={ () =>  {}}  
            >   
            {celda("left", {width:"6rem", fontSize:"12px", paddingRight:"10px"}, elemnto.Alias,index+3) }     
            {celda("center", {width:"6rem", fontSize:"12px", paddingRight:"10px"},elemnto.Descr ,index+2) }
            {celda("left", {width:"6rem", paddingRight:"6px"}, elemnto.Horometro ,index+1) }        
            {celda("left", {width:"6rem",  fontSize:"12px", paddingRight:"4px"}, elemnto.NoEco ,index+1) }   
            {celda("left", {width:"6rem", fontSize:"12px", paddingRight:"4px"}, elemnto.Serie ,index+1) } 
            {celda("left", {width:"8rem", fontSize:"12px", paddingRight:"4px"}, elemnto.Notas ,index+1) }   
            </TableRow>              
            );                        
        })}                                                
        </TableBody>
        </Table>
    </TableContainer>        
    ); 
    }
  
  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={()=>{}}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} maxTam={true}
    setEspera={setEspera}  tamanio={"lg"} btnDesact={btnDesact}
  >
   <Box display={"flex"} flexDirection={"column"} mb={2} style={{minWidth:"10rem"}}>
    {listOriginal.length!==0 ? TablaEstr(listOriginal):<Typography>Sin registros</Typography>}
    </Box>

      
      
  </Modal>
  );
}
 
export default ModalDetalle;